import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const DownloadEnergyScoreGeneric = (exportList, project) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}EnergyScore/DownloadEnergyScoreGeneric?project=${project}&${exportList.map(ds => `datasetNames=${ds}`).join('&')}`
});

export const DownloadEnergyScoreNonGeneric = (exportList, project) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}EnergyScore/DownloadEnergyScoreNonGeneric?project=${project}&${exportList.map(ds => `datasetNames=${ds}`).join('&')}`
});
